// extracted by mini-css-extract-plugin
export default {"container":"Services_container__vVeSb","title":"Services_title__rZsHx","slide":"Services_slide__TDGJm"};